import { useCallback } from 'react';
import { usePodObserver } from 'hooks/use-pod-observer';
import { requestIdleCallback } from 'utils/settimeout-wrapper';
import { sendAdTechEvent } from 'analytics/gtmServerFunctions';

interface AdtechTracking {
  impressionUrls: string[];
  vendor: string;
}

export function useAdtechObserver<T extends HTMLElement = HTMLElement>(
  sponsorshipId: string,
  tracking: AdtechTracking,
): (node: T | null) => void {
  const observerRef = usePodObserver(
    useCallback(() => {
      requestIdleCallback(() =>
        sendAdTechEvent({
          eventType: 'impression',
          sponsorshipId,
          trackingUrls: tracking.impressionUrls,
          vendor: tracking.vendor,
        }),
      );
    }, [sponsorshipId, tracking.impressionUrls, tracking.vendor]),
  ) as React.RefObject<T | null>;

  const callbackRef = useCallback(
    (node: T | null) => {
      if (node) {
        observerRef.current = node;
      }
    },
    [observerRef],
  );

  return callbackRef;
}
